import React from "react";
import classNames from "classnames";
import { InputBase } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import styled from "styled-components";

function TextArea({ isVisible = true, classes, parentClass, className, onChange, onBlur, text, placeholder, inputProps, readOnly = false, rows = 3, ...rest }) {
    return isVisible ? (
        <div className={classNames(classes.root, parentClass, className)} {...rest}>
            <InputBase
                readOnly={readOnly}
                onChange={event => onChange && onChange(event.target.value)}
                onBlur={event => onBlur && onBlur(event.target.value)}
                multiline
                fullWidth
                placeholder={placeholder}
                rows={rows}
                classes={{ focused: classes.focus }}
                className={classes.textArea}
                inputProps={{ className: classes.input, ...inputProps }}
                value={text || ""}
                onKeyDown={event => event.stopPropagation()}
            />
        </div>
    ) : null;
}

TextArea.propTypes = {
    isVisible: PropTypes.bool,
    classes: PropTypes.object,
    parentClass: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    text: PropTypes.string,
    placeholder: PropTypes.string,
    inputProps: PropTypes.object,
    readOnly: PropTypes.bool,
    rows: PropTypes.number
};

const StyledTextArea = withStyles({
    root: {
        border: "1px solid #ddd",
        borderRadius: "1px",
        width: "100%",
        height: "100%",
        fontFamily: "Source Sans Pro"
    },
    focus: {
        outline: "3px solid #82BDFA"
    },
    textArea: {
        backgroundColor: "#FFFFFF",
        borderRadius: "1px",
        color: "#222"
    },
    input: {
        fontSize: "14px",
        padding: "4px 10px"
    }
})(TextArea);

export const NoteTextArea = styled(StyledTextArea)`
    &&& {
        border-radius: 1px;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

        &:focus-within {
            border-color: #11a9e2;
            box-shadow: 0 0 0 1px #11a9e2;
        }

        .MuiInputBase-root.Mui-focused {
            outline: none;
        }

        textarea {
            font-family: "Source Sans Pro", sans-serif;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #222;

            &::placeholder {
                font-family: "Source Sans Pro", sans-serif;
                font-weight: 400;
                color: #999;
                opacity: 1;
            }
        }
    }
`;

export default StyledTextArea;

